import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Vehicle } from '../../models/vehicle';

@Component({
  selector: 'soft-vehicle-list-view',
  imports: [],
  templateUrl: './vehicle-list-view.component.html',
  styleUrl: './vehicle-list-view.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleListViewComponent {
  readonly vehicle = input.required<Vehicle>();
}
